import _ from 'lodash';
import * as api from './api';

export const fetchAuditAgainstEntityId = async (params) => {
  try {
    let res = await api.fetchAuditAgainstEntityId(params);
    return res;
  } catch (err) {
    throw err;
  }
};
